import { createTheme } from "@mui/material/styles";
import type {} from "@mui/lab/themeAugmentation";

import { palette } from "./palette";
import { components } from "./components";

const theme = createTheme({
    spacing: 8,
    palette: palette,
    typography: {
        fontFamily:
            '"Titillium Web", "IBM Plex Sans" , "Open Sans", sans-serif',
        allVariants: {
            color: "white",
        },
        h1: {},
        h2: {
            fontWeight: 600,
            fontSize: "2em",
        },
    },
    components: components,
});

export default theme;
